let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kGTq5")).then(() => parcelRequire('c5unR'));